// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * @typedef {Object} PaginationOpts
 * @property {number} limit
 * @property {number} skip
 */

export const DEFAULT_LOGS_PAGINATION_OPTS = {
  limit: 50,
  skip: 0
};

/**
 * @typedef {Object} ActivityLog
 * @property {string} id
 * @property {number} createdAt
 * @property {string} createdBy
 * @property {string} organization
 * @property {string} target
 * @property {number} startAt
 * @property {number} endAt
 * @property {number} arrivedAt
 * @property {string} arrivedBy
 * @property {number} cancelledAt
 * @property {string} cancelledBy
 * @property {Object} meta
 */

const state = {
  /**
   * list of activity logs
   * @type {ActivityLog[]}
   **/
  logs: [],

  /**
   * - total number of stored (in db) icd10 fixtures
   * - used for pagination
   * @type {number}
   */
  logsTotal: 0,

  /**
   * @type {PaginationOpts}
   */
  logsPaginationOpts: { ...DEFAULT_LOGS_PAGINATION_OPTS }
};

export default state;
